import { registerRootComponent } from 'expo';
import Clarity from '@microsoft/clarity';
import "./global.css";
import App from './App';

try {
  if(
    typeof window !== "undefined" &&
    window.location.hostname !== "localhost"
  ){
    Clarity.init("r5hw2j0zx8");
  }
} catch (error) {
  console.log(error); 
};

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);

// npx expo || add "npx"